import React, { useEffect, useImperativeHandle, useRef, forwardRef, useState } from "react";
import { Col, Form, InputGroup, Row } from "react-bootstrap";
import {
  amountFormatter,
  checkKey,
  formatNumber,
  lpad,
  nvl,
  parseNumber,
  toNull,
  toSingleByte,
  onFocusText,
  CONST_EXPENSE_CL_TAX_10,
  CONST_EXPENSE_CL_TAX_EXEMPT,
  CONST_EXPENSE_CL_TAX_NON_TAX,
  CONST_EXPENSE_CL_TAX_08,
  onKeyDownNext,
  moveCellByArrow,
  sleepByPromise, onKeyDownShortCut, calcLineAmount, calcLineTaxAmount, calcLineWithholdTaxAmount
} from "../CMUtil";
import { getAPI } from "../APIUtil";
import AsyncSelect from "react-select/async";
import { Typeahead } from "react-bootstrap-typeahead";

export const PayDtlLine = React.forwardRef((props, ref) => {

  const iniAccCd = useRef(true);

  const [index, setIndex] = useState("");
  const [payDtlId, setPayDtlId] = useState("");
  const [payId, setPayId] = useState("");

  const [expenseSelected, setExpenseSelected] = useState(null);
  const [remarkSelected, setRemarkSelected] = useState(null);

  const [accSelected, setAccSelected] = useState(null);
  const [accSuffixSelected, setAccSuffixSelected] = useState(null);

  const [modalAuthorCd, setModalAuthorCd] = useState("");
  const [expenseCl, setExpenseCl] = useState(0);
  const [accCd, setAccCd] = useState("");
  const [accSuffixCd, setAccSuffixCd] = useState("");
  const [invNo, setInvNo] = useState("");
  const [remarkCd, setRemarkCd] = useState("");
  const [remarkNm, setRemarkNm] = useState("");
  const [note, setNote] = useState("");
  const [qty, setQty] = useState(0);
  const [page, setPage] = useState(0);
  const [price, setPrice] = useState(0);
  const [lineAmount, setLineAmount] = useState(0);
  const [lineAmountEx, setLineAmountEx] = useState(0);
  const [taxTypeCdOrg, setTaxTypeCdOrg] = useState("");
  const [lineTaxTypeCd, setLineTaxTypeCd] = useState("");
  const [lineTaxRate, setLineTaxRate] = useState(0);
  const [lineTaxAmount, setLineTaxAmount] = useState(0);
  const [lineTotalAmount, setLineTotalAmount] = useState(0);
  const [lineWithHoldTaxAmount, setLineWithHoldTaxAmount] = useState(0);
  const [linePayAmount, setLinePayAmount] = useState(0);

  const [authorCdOrg, setAuthorCdOrg] = useState("");
  const [expenseClOrg, setExpenseClOrg] = useState("");
  const [remarkCdOrg, setRemarkCdOrg] = useState("");
  const [remarkNmOrg, setRemarkNmOrg] = useState("");
  const [noteOrg, setNoteOrg] = useState("");
  const [qtyOrg, setQtyOrg] = useState("");
  const [pageOrg, setPageOrg] = useState("");
  const [priceOrg, setPriceOrg] = useState("");
  const [lineAmountOrg, setLineAmountOrg] = useState("");
  const [lineAmountExOrg, setLineAmountExOrg] = useState("");
  const [lineTaxAmountOrg, setLineTaxAmountOrg] = useState("");

  const [isHeadUpdated, setIsHeadUpdated] = useState(false);
  const [isLineUpdated, setIsLineUpdated] = useState(false);

  const [selectMenuOpen, setSelectMenuOpen] = useState(false);

  const _ref = useRef(null);

  //初期化
  useEffect(() => {

    const update = async () => {
      // 初期化
      setIndex(nvl(props.index));
      setTaxTypeCdOrg(nvl(props.consumptionTax));
      let line = props.line;
      setPayDtlId(nvl(line.pay_dtl_id));
      setPayId(nvl(line.pay_id));
      if (line.expense_cl) {
        setExpenseSelected([{ id: line.expense_cl, name: lpad(nvl(line.expense_cl), 2, "0") + " " + nvl(line.expense_cl_nm) }]);
        setExpenseCl(line.expense_cl);
      }
      if (line.acc_cd) {
        setAccSelected([{ id: line.acc_cd, name: lpad(nvl(line.acc_cd), 2, "0") + " " + nvl(line.acc_nm) }]);
        setAccCd(line.acc_cd);
      }
      if (line.acc_suffix_cd) {
        setAccSuffixSelected([{ id: line.acc_suffix_cd, name: lpad(nvl(line.acc_suffix_cd), 2, "0") + " " + nvl(line.acc_suffix_nm) }]);
        setAccSuffixCd(line.acc_suffix_cd);
      }
      setInvNo(nvl(line.inv_no));
      if (line.remark_cd) {
        setRemarkCd(line.remark_cd);
        setRemarkSelected({
          id: line.remark_cd,
          name: line.remark_cd
        });
      }
      setNote(nvl(line.note));
      setPrice(nvl(amountFormatter(line.price)));
      setQty(nvl(amountFormatter(line.qty)));
      setPage(nvl(amountFormatter(line.page)));
      setLineAmount(nvl(amountFormatter(line.line_amount)));
      setLineAmountEx(nvl(amountFormatter(line.line_amount_ex)));
      setLineTaxTypeCd(nvl(line.line_tax_type_cd));
      setLineTaxRate(nvl(line.line_tax_rate));
      setLineTaxAmount(nvl(line.line_tax_amount));
      setLineTotalAmount(nvl(line.line_total_amount));
      setLineWithHoldTaxAmount(nvl(line.line_withhold_tax_amount));
      setLinePayAmount(nvl(line.line_pay_amount));
      setAuthorCdOrg(nvl(line.author_cd));
      setExpenseClOrg(nvl(line.expense_cl));
      setNoteOrg(nvl(line.note));
      setPriceOrg(nvl(amountFormatter(line.price)));
      setQtyOrg(nvl(amountFormatter(line.qty)));
      setPageOrg(nvl(amountFormatter(line.page)));
      setLineAmountOrg(amountFormatter(nvl(line.line_amount)));
      setLineAmountExOrg(nvl(amountFormatter(line.line_amount_ex)));
    }

    update();

  }, []);

  useImperativeHandle(ref, () => ({
    getStates: () => {
      // 数値項目の未入力は0、文字列項目の未入力はnull（明細が空の行は全てnullのまま）
      const hasData = !!(expenseCl || accCd);
      const toNum = (val) => {
        const n = toNull(parseNumber(val));
        return n == null && hasData ? 0 : n;
      };
      return {
        index: toNull(index),
        pay_id: toNull(payId),
        pay_dtl_id: toNull(payDtlId),
        expense_cl: toNull(expenseCl),
        acc_cd: toNull(accCd),
        acc_suffix_cd: toNull(accSuffixCd),
        inv_no: toNull(invNo),
        remark_cd: toNull(remarkCd),
        note: toNull(note),
        price: toNum(price),
        qty: toNum(qty),
        page: toNum(page),
        line_amount: toNum(lineAmount),
        line_amount_ex: toNum(lineAmountEx),
        line_tax_type_cd: toNull(lineTaxTypeCd),
        line_tax_rate: toNull(lineTaxRate),
        line_tax_amount: toNum(lineTaxAmount), //親で計算する
        line_total_amount: toNum(lineTotalAmount), //親で計算する
        line_withhold_tax_amount: toNum(lineWithHoldTaxAmount), //親で計算する
        line_pay_amount: toNum(linePayAmount), //親で計算する
        create_pg: 'PayDtlLine',
        update_pg: 'PayDtlLine',
        is_head_updated: isHeadUpdated,
        is_line_updated: isLineUpdated
      };
    },
    setLineTaxAmount: (pLineTaxAmount) => {
      setLineTaxAmount(pLineTaxAmount);
    },
    setLineTotalAmount: (oLineTotalAmount) => {
      setLineTotalAmount(oLineTotalAmount);
    },
    setLineWithholdTaxAmount: (pWithholdTaxAmount) => {
      setLineWithHoldTaxAmount(pWithholdTaxAmount);
    },
    setLinePayAmount: (pLinePayAmount) => {
      setLinePayAmount(pLinePayAmount);
    },
    isEmpty: () => {
      if (expenseCl) {
        return false;
      }
      if (accCd) {
        return false;
      }
      if (accSuffixCd) {
        return false;
      }
      if (invNo) {
        return false;
      }
      if (remarkCd) {
        return false;
      }
      if (note) {
        return false;
      }
      if (price) {
        return false;
      }
      if (qty) {
        return false;
      }
      if (page) {
        return false;
      }
      if (lineAmount) {
        return false;
      }
      if (lineAmountEx) {
        return false;
      }
      return true;
    }
  }), [
    expenseCl,
    accCd,
    accSuffixCd,
    invNo,
    remarkCd,
    note,
    price,
    qty,
    page,
    lineAmount,
    lineAmountEx,
    lineTaxTypeCd,
    lineTaxRate,
    lineTaxAmount,
    lineTotalAmount,
    lineWithHoldTaxAmount,
    linePayAmount
  ]);

  useEffect(() => {
    const update = async () => {
      var locIsHeadUpdated = modalAuthorCd !== authorCdOrg;
      setIsHeadUpdated(locIsHeadUpdated);
    }
    update();
  }, [
    modalAuthorCd
  ]);

  useEffect(() => {
    const update = async () => {
      props.calcTotal();
    }
    update();
  }, [
    expenseCl
  ]);

  const onSearchExpense = async (query) => {
    if (!query) {
      return props.expenseList;
    }
    let searchCondition = {
      expense_cl_nm: query,
      pay_grp_type:"原稿料"
    }
    const res = await getAPI("ms_expense_typeahead_view", searchCondition);
    let o = res.results.map((obj) => ({
      name: lpad(nvl(obj.expense_cl), 2, "0") + " " + nvl(obj.expense_cl_nm),
      id: obj.expense_cl
    }));
    return o;
  }

  const handleChangeExpense = async (value) => {
    if (!value) {
      setExpenseSelected(null);
      setExpenseCl("");
      return;
    }
    setExpenseSelected(value);
    setExpenseCl(value.id);

    // 原稿料 ⇔ 経費と変更された場合、入力値をクリアする
    let prevType = (expenseCl === CONST_EXPENSE_CL_TAX_10 || expenseCl === CONST_EXPENSE_CL_TAX_08 || expenseCl === CONST_EXPENSE_CL_TAX_EXEMPT || expenseCl === CONST_EXPENSE_CL_TAX_NON_TAX) ? "ex" : "";
    let currType = (value.id === CONST_EXPENSE_CL_TAX_10 || value.id === CONST_EXPENSE_CL_TAX_08 || value.id === CONST_EXPENSE_CL_TAX_EXEMPT || value.id === CONST_EXPENSE_CL_TAX_NON_TAX) ? "ex" : "";
    if (prevType !== currType) {
      setPrice("");
      setQty("");
      setPage("");
      setLineAmount("");
      setLineAmountEx("");
    }

    if (value.id === CONST_EXPENSE_CL_TAX_08) {
      // 経費８％
      setLineTaxTypeCd(taxTypeCdOrg);
      setLineTaxRate(8);
    } else if (value.id === CONST_EXPENSE_CL_TAX_EXEMPT || value.id === CONST_EXPENSE_CL_TAX_NON_TAX) {
      // 経費非課税
      setLineTaxTypeCd(3);
      setLineTaxRate(0);
    } else {
      setLineTaxTypeCd(taxTypeCdOrg);
      setLineTaxRate(10);
    }
    onKeyDownNext();
  }

  const onSearchAcc = async (query) => {
    if (!query) {
      return props.accList;
    }
    let searchCondition = {
      search_value: query
    }
    const res = await getAPI("ms_acc1_typeahead_view", searchCondition);
    let o = res.results.map((obj) => ({
      name: lpad(nvl(obj.acc_cd), 3, "0") + " " + nvl(obj.acc_nm),
      id: obj.acc_cd
    }));
    return o;
  }

  const handleChangeAcc = async (value) => {
    setAccSelected(value);
    setAccCd(value ? value.id : "");
    if (!value) {
      handleClearLine();
      return;
    }
    setTimeout(() => {
      onKeyDownNext();
    }, 100); // バグ対応：遅延させることでカーソル表示
  }

  const onSearchAccSuffix = async (query) => {
    let searchCondition = {
      acc_cd: accCd,
      search_value: query
    }
    const res = await getAPI("ms_acc2_typeahead_view", searchCondition);
    let o = res.results.map((obj) => ({
      name: lpad(nvl(obj.acc_suffix_cd), 3, "0") + " " + nvl(obj.acc_suffix_nm),
      id: obj.acc_suffix_cd
    }));
    return o;
  }

  const handleChangeAccSuffix = async (value) => {
    setAccSuffixSelected(value);
    setAccSuffixCd(value ? value.id : "");
    onKeyDownNext();
  }

  const onSearchRemark = async (query) => {
    if (!query) {
      return props.remarkList;
    }
    let searchCondition = {
      remark_nm: query
    }
    const res = await getAPI("ms_remark_typeahead_view", searchCondition);
    return res.results.map((obj) => ({
      name: nvl(obj.remark_cd) + " " + nvl(obj.remark_nm),
      id: obj.remark_cd,
      remark_nm: nvl(obj.remark_nm)
    }));
  }

  const handleChangeRemark = async (value) => {
    if (!value) {
      setRemarkSelected(null);
      setRemarkCd("");
      return;
    }
    setRemarkSelected({
      id: value.id,
      name: value.id
    });
    setRemarkCd(value.id);
    setNote(value.remark_nm);
    onKeyDownNext();
  }

  const onFocusCol = (e) => {
    onFocusText(e);
    props.appendLine();
  }

  const onBlurPrice = async (price) => {
    let cPrice = parseNumber(toSingleByte(price));
    if (cPrice === "" && !lineTotalAmount) {
      return; // 未入力のまま通過しただけなら処理終了
    }
    let cLineAmount = calcLineAmount(cPrice, qty, page) || 0; // 空は0として再計算
    let cLineTaxAmount = calcLineTaxAmount(expenseCl, cLineAmount);
    let cLineTotalAmount = cLineAmount + cLineTaxAmount;
    let cLineWithholdTaxAmount = calcLineWithholdTaxAmount(cLineAmount, props.withholdingObjectCl, null, remarkCd);
    let cLinePayAmount = cLineTotalAmount - cLineWithholdTaxAmount;
    setPrice(amountFormatter(cPrice));
    setLineAmount(nvl(amountFormatter(cLineAmount)));
    setLineTaxAmount(amountFormatter(cLineTaxAmount));
    setLineTotalAmount(amountFormatter(cLineAmount + cLineTaxAmount));
    setLineWithHoldTaxAmount(amountFormatter(cLineWithholdTaxAmount));
    setLinePayAmount(amountFormatter(cLinePayAmount))
    setTimeout(() => {
      props.calcTotal();
    }, 0);
  }

  const onBlurQty = async (qty) => {
    let cQty = parseNumber(toSingleByte(qty));
    if (cQty === "" && !lineTotalAmount) {
      return; // 未入力のまま通過しただけなら処理終了
    }
    let cLineAmount = calcLineAmount(price, cQty, page) || 0; // 空は0として再計算
    let cLineTaxAmount = calcLineTaxAmount(expenseCl, cLineAmount);
    let cLineTotalAmount = cLineAmount + cLineTaxAmount;
    let cLineWithholdTaxAmount = calcLineWithholdTaxAmount(cLineAmount, props.withholdingObjectCl, null, remarkCd);
    let cLinePayAmount = cLineTotalAmount - cLineWithholdTaxAmount;
    setQty(amountFormatter(cQty));
    setLineAmount(nvl(amountFormatter(cLineAmount)));
    setLineTaxAmount(amountFormatter(cLineTaxAmount));
    setLineTotalAmount(amountFormatter(cLineTotalAmount));
    setLineWithHoldTaxAmount(amountFormatter(cLineWithholdTaxAmount));
    setLinePayAmount(amountFormatter(cLinePayAmount))
    setTimeout(() => {
      props.calcTotal();
    }, 0);
  }

  const onBlurPage = async (page) => {
    let cPage = parseNumber(toSingleByte(page));
    if (cPage === "" && !lineTotalAmount) {
      return; // 未入力のまま通過しただけなら処理終了
    }
    let cLineAmount = calcLineAmount(price, qty, cPage) || 0; // 空は0として再計算
    let cLineTaxAmount = calcLineTaxAmount(expenseCl, cLineAmount);
    let cLineTotalAmount = cLineAmount + cLineTaxAmount;
    let cLineWithholdTaxAmount = calcLineWithholdTaxAmount(cLineAmount, props.withholdingObjectCl, null, remarkCd);
    let cLinePayAmount = cLineTotalAmount - cLineWithholdTaxAmount;
    setPage(amountFormatter(toSingleByte(cPage)));
    setLineAmount(nvl(amountFormatter(cLineAmount)));
    setLineTaxAmount(amountFormatter(cLineTaxAmount));
    setLineTotalAmount(amountFormatter(cLineTotalAmount));
    setLineWithHoldTaxAmount(amountFormatter(cLineWithholdTaxAmount));
    setLinePayAmount(amountFormatter(cLinePayAmount))
    setTimeout(() => {
      props.calcTotal();
    }, 0);
  }

  const onBlurLineAmount = async (lineAmount) => {
    let cLineAmount = parseNumber(toSingleByte(lineAmount)) || 0; // 空は0として扱う
    let cLineTaxAmount = calcLineTaxAmount(expenseCl, cLineAmount);
    let cLineTotalAmount = cLineAmount + cLineTaxAmount;
    let cLineWithholdTaxAmount = calcLineWithholdTaxAmount(cLineAmount, props.withholdingObjectCl, null, remarkCd);
    let cLinePayAmount = cLineTotalAmount - cLineWithholdTaxAmount;
    setLineAmount(nvl(amountFormatter(cLineAmount)));
    setLineTaxAmount(amountFormatter(cLineTaxAmount));
    setLineTotalAmount(amountFormatter(cLineTotalAmount));
    setLineWithHoldTaxAmount(amountFormatter(cLineWithholdTaxAmount));
    setLinePayAmount(amountFormatter(cLinePayAmount))
    setTimeout(() => {
      props.calcTotal();
    }, 0);
  }

  const onBlurLineAmountEx = async (lineAmountEx) => {
    let cLineAmountEx = parseNumber(toSingleByte(lineAmountEx)) || 0; // 空は0として扱う
    let cLineTaxAmount = calcLineTaxAmount(expenseCl, cLineAmountEx);
    let cLineAmount = cLineAmountEx - cLineTaxAmount;
    let cLineTotalAmount = cLineAmountEx;
    let cLineWithholdTaxAmount = calcLineWithholdTaxAmount(cLineAmount, props.withholdingObjectCl, null, remarkCd);
    let cLinePayAmount = cLineTotalAmount - cLineWithholdTaxAmount;
    setLineAmountEx(nvl(amountFormatter(cLineAmountEx)));
    setLineAmount("");
    setLineTaxAmount(amountFormatter(cLineTaxAmount));
    setLineTotalAmount(amountFormatter(cLineTotalAmount));
    setLineWithHoldTaxAmount(amountFormatter(cLineWithholdTaxAmount));
    setLinePayAmount(amountFormatter(cLinePayAmount))
    setTimeout(() => {
      props.calcTotal();
    }, 0);
  }

  const handleChangeNote = (e) => {
    const val = e.target.value;
    setNote(val);
  };

  const handleKeyDownRemark = (e) => {
    // エンター
    if (e.target.tagName === "TEXTAREA" && e.key === "Enter") {
      if (e.altKey) {
        e.preventDefault();
        const el = e.target;
        const start = el.selectionStart;
        const end = el.selectionEnd;
        const newVal = note.slice(0, start) + "\n" + note.slice(end);
        setNote(newVal);
        setTimeout(() => {
          el.selectionStart = el.selectionEnd = start + 1;
        }, 0);
      } else {
        onKeyDownNext(e);
      }
    }
  }

  const handleClearLine = () => {
    setAccSelected({});
    setAccCd("");
    setAccSuffixSelected({});
    setAccSuffixCd("");
    setExpenseSelected({});
    setExpenseCl("");
    setInvNo("");
    setRemarkSelected({});
    setRemarkCd("");
    setNote("");
    setPrice("");
    setQty("");
    setPage("");
    setLineAmount("");
    setLineAmountEx("");
  }

  return (
    <div>
      <div
        className="container-main-detail-list d-flex flex-row"
        onKeyDownCapture={(e) => {
          // 矢印キーでセル移動（メニュー表示中は選択肢操作を優先）
          if (!selectMenuOpen && moveCellByArrow(e)) {
            e.stopPropagation();
          }
        }}
        onKeyDown={(e) => onKeyDownShortCut(e, null, props.onClickSavePayDtlModal, props.onKeyDownEscModal)}
      >
        <div className="container" style={{ flex: "70 1 0%", padding: "0" }}>
          <Row className="tbl-b-00" style={{ marginLeft: "0", marginRight: "0" }}>
            <Col lg="2" className="col-editable tbl-b-00-start" style={{ padding: "0" }}>
              <AsyncSelect
                tabIndex={100 * (index + 1) + 1001}
                className="async-select"
                classNamePrefix="async-select"
                components={{ DropdownIndicator: null, ClearIndicator: null }}
                cacheOptions
                defaultOptions
                value={accSelected}
                onFocus={e => props.appendLine()}
                onMenuOpen={e => setSelectMenuOpen(true)}
                onMenuClose={e => setSelectMenuOpen(false)}
                onKeyDown={e => {
                  if (!selectMenuOpen) {
                    if (e.key === "ArrowDown") {
                      setSelectMenuOpen(true);
                      return;
                    }
                    setTimeout(() => {
                      onKeyDownNext(e);
                    }, 100); // バグ対応：遅延させることでカーソル表示
                  }
                }}
                getOptionLabel={e => Object.keys(e).length === 0 ? "" : `${e.name}`}
                getOptionValue={e => e.id}
                loadOptions={e => onSearchAcc(e)}
                onChange={e => handleChangeAcc(e)}
                placeholder=""
                isClearable
              />
            </Col>
            <Col lg="2" className="col-editable" style={{ padding: "0" }}>
              <AsyncSelect
                key={accCd || 'default'}
                tabIndex={100 * (index + 1) + 1002}
                className="async-select"
                classNamePrefix="async-select"
                components={{ DropdownIndicator: null, ClearIndicator: null }}
                cacheOptions
                defaultOptions
                value={accSuffixSelected}
                onFocus={e => props.appendLine()}
                onMenuOpen={e => setSelectMenuOpen(true)}
                onMenuClose={e => setSelectMenuOpen(false)}
                onKeyDown={e => {
                  if (!selectMenuOpen) {
                    if (e.key === "ArrowDown") {
                      setSelectMenuOpen(true);
                      return;
                    }
                    setTimeout(() => {
                      onKeyDownNext(e);
                    }, 100); // バグ対応：遅延させることでカーソル表示
                  }
                }}
                getOptionLabel={e => Object.keys(e).length === 0 ? "" : `${e.name}`}
                getOptionValue={e => e.id}
                loadOptions={e => onSearchAccSuffix(e)}
                onChange={e => handleChangeAccSuffix(e)}
                placeholder=""
                isClearable
                styles={{
                  menu: (base) => ({
                    ...base,
                    minWidth: "300px",
                  }),
                  option: (base) => ({
                    ...base,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }),
                }}
              />
            </Col>
            <Col lg="2" className="col-editable" style={{ padding: "0" }}>
              <AsyncSelect
                tabIndex={100 * (index + 1) + +1003}
                className="async-select"
                classNamePrefix="async-select"
                components={{ DropdownIndicator: null, ClearIndicator: null }}
                cacheOptions
                defaultOptions
                value={expenseSelected}
                onFocus={e => props.appendLine()}
                onMenuOpen={e => setSelectMenuOpen(true)}
                onMenuClose={e => setSelectMenuOpen(false)}
                onKeyDown={e => {
                  if (!selectMenuOpen) {
                    if (e.key === "ArrowDown") {
                      setSelectMenuOpen(true);
                      return;
                    }
                    setTimeout(() => {
                      onKeyDownNext(e);
                    }, 100); // バグ対応：遅延させることでカーソル表示
                  }
                }}
                getOptionLabel={e => Object.keys(e).length === 0 ? "" : `${e.name}`}
                getOptionValue={e => e.id}
                loadOptions={e => onSearchExpense(e)}
                onChange={e => handleChangeExpense(e)}
                placeholder=""
                isClearable
                style={{
                  option: (base) => ({
                    whiteSpace: "nowrap"
                  })
                }}
              />
            </Col>
            <Col lg="2" className="input-group col-editable" style={{ padding: "0" }}>
              <Form.Control
                tabIndex={100 * (index + 1) + +1004}
                id="inv_no"
                type="text"
                value={invNo}
                onKeyDown={e => {
                  onKeyDownNext(e);
                }}
                onFocus={e => onFocusCol(e)}
                onChange={e => setInvNo(e.target.value)}
              />
            </Col>
            <Col lg="4" className="col-editable" style={{ padding: "0", position: 'relative', display: 'flex', flexDirection: 'row', gap: '4px' }}>
              <div style={{ width: "40px" }}>
                <AsyncSelect
                  tabIndex={100 * (index + 1) + 1005}
                  className="async-select"
                  classNamePrefix="async-select"
                  components={{ DropdownIndicator: null, ClearIndicator: null }}
                  cacheOptions
                  defaultOptions
                  value={remarkSelected}
                  onFocus={e => props.appendLine()}
                  onMenuOpen={e => setSelectMenuOpen(true)}
                  onMenuClose={e => setSelectMenuOpen(false)}
                  onKeyDown={e => {
                    if (!selectMenuOpen) {
                      if (e.key === "ArrowDown") {
                        setSelectMenuOpen(true);
                        return;
                      }
                      setTimeout(() => {
                        onKeyDownNext(e);
                      }, 100); // バグ対応：遅延させることでカーソル表示
                    }
                  }}
                  getOptionLabel={e => Object.keys(e).length === 0 ? "" : `${e.name}`}
                  getOptionValue={e => e.id}
                  loadOptions={e => onSearchRemark(e)}
                  onChange={handleChangeRemark}
                  placeholder=""
                  isClearable
                  styles={{
                    menu: (base) => ({
                      ...base,
                      minWidth: "300px",
                    }),
                    option: (base) => ({
                      ...base,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }),
                  }}
                />
              </div>
              <div className="input-group col-editable col-remark" style={{ fieldSizing: "content", flex: 1, minWidth: 0 }}>
                <Form.Control
                  tabIndex={100 * (index + 1) + 1006}
                  id="note"
                  as="textarea"
                  rows={1}
                  style={{ fieldSizing: "content", overflow: "hidden", resize: "none", border: "1px solid transparent", backgroundColor: "transparent", padding: "8px" }}
                  value={note}
                  onKeyDown={e => {
                    handleKeyDownRemark(e);
                  }}
                  onFocus={e => onFocusCol(e)}
                  onChange={e => handleChangeNote(e)}
                />
              </div>
            </Col>
          </Row>
        </div>
        <div className="container" style={{ flex: "30 1 0%", padding: "0" }}>
          <Row className="tbl-b-00" style={{ marginLeft: "0", marginRight: "0", height: "100%" }}>
            <Col className="input-group col-editable col-lg" style={{ padding: "0" }}>
              <Form.Control
                tabIndex={100 * (index + 1) + 1027}
                id="price"
                type="text"
                inputMode="numeric"
                style={{ textAlign: "right" }}
                value={price}
                disabled={expenseCl === CONST_EXPENSE_CL_TAX_10 || expenseCl === CONST_EXPENSE_CL_TAX_08 || expenseCl === CONST_EXPENSE_CL_TAX_EXEMPT || expenseCl === CONST_EXPENSE_CL_TAX_NON_TAX}
                onKeyPress={e => {
                  checkKey(e, /[0-9\-]/);
                  onKeyDownNext(e);
                }}
                onFocus={e => onFocusCol(e)}
                onChange={e => setPrice(e.target.value)}
                onBlur={e => onBlurPrice(e.target.value)}
              />
            </Col>
            <Col className="input-group col-editable col-lg" style={{ padding: "0" }}>
              <Form.Control
                tabIndex={100 * (index + 1) + 1028}
                id="qty"
                type="text"
                inputMode="numeric"
                style={{ textAlign: "right" }}
                value={qty}
                disabled={expenseCl === CONST_EXPENSE_CL_TAX_10 || expenseCl === CONST_EXPENSE_CL_TAX_08 || expenseCl === CONST_EXPENSE_CL_TAX_EXEMPT || expenseCl === CONST_EXPENSE_CL_TAX_NON_TAX}
                onKeyPress={e => {
                  checkKey(e, /[0-9\-]/);
                  onKeyDownNext(e);
                }}
                onFocus={e => onFocusCol(e)}
                onChange={e => setQty(e.target.value)}
                onBlur={e => onBlurQty(e.target.value)}
              />
            </Col>
            <Col className="input-group col-editable col-lg" style={{ padding: "0" }}>
              <Form.Control
                tabIndex={100 * (index + 1) + 1029}
                id="page"
                type="text"
                inputMode="numeric"
                style={{ textAlign: "right" }}
                value={page}
                disabled={expenseCl === CONST_EXPENSE_CL_TAX_10 || expenseCl === CONST_EXPENSE_CL_TAX_08 || expenseCl === CONST_EXPENSE_CL_TAX_EXEMPT || expenseCl === CONST_EXPENSE_CL_TAX_NON_TAX}
                onKeyPress={e => {
                  checkKey(e, /[0-9\-]/);
                  onKeyDownNext(e);
                }}
                onFocus={e => onFocusCol(e)}
                onChange={e => setPage(e.target.value)}
                onBlur={e => onBlurPage(e.target.value)}
              />
            </Col>
            <Col className="input-group col-editable col-lg" style={{ padding: "0" }}>
              <Form.Control
                tabIndex={100 * (index + 1) + 1030}
                id="line_amount"
                type="text"
                inputMode="numeric"
                style={{ textAlign: "right" }}
                value={lineAmount}
                disabled={expenseCl === CONST_EXPENSE_CL_TAX_10 || expenseCl === CONST_EXPENSE_CL_TAX_08 || expenseCl === CONST_EXPENSE_CL_TAX_EXEMPT || expenseCl === CONST_EXPENSE_CL_TAX_NON_TAX}
                onKeyPress={e => {
                  checkKey(e, /[0-9\-]/);
                  onKeyDownNext(e);
                }}
                onFocus={e => onFocusCol(e)}
                onChange={e => setLineAmount(e.target.value)}
                onBlur={e => onBlurLineAmount(e.target.value)}
              />
            </Col>
            <Col className="input-group col-editable col-lg" style={{ padding: "0" }}>
              <Form.Control
                tabIndex={100 * (index + 1) + 1031}
                id="line_amount_ex"
                type="text"
                inputMode="numeric"
                style={{ textAlign: "right" }}
                value={lineAmountEx}
                disabled={expenseCl !== CONST_EXPENSE_CL_TAX_10 && expenseCl !== CONST_EXPENSE_CL_TAX_08 && expenseCl !== CONST_EXPENSE_CL_TAX_EXEMPT && expenseCl !== CONST_EXPENSE_CL_TAX_NON_TAX}
                onKeyPress={e => {
                  checkKey(e, /[0-9\-]/);
                  onKeyDownNext(e);
                }}
                onFocus={e => onFocusCol(e)}
                onChange={e => setLineAmountEx(e.target.value)}
                onBlur={e => onBlurLineAmountEx(e.target.value)}
              />
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
});

export default React.memo(PayDtlLine);
